























































import { Vue, Component } from "@/shared/vuepack";
import { BalanceTransferMethod } from "@/shared/types";
import Button from "@/shared/components/ui/Button.vue";
import { useBalanceTransferStore } from "@/employee/store/balanceTransfer";
import { Home } from "@/shared/route-names";

@Component({
  components: {
    Button
  }
})
export default class TransferFunds extends Vue {
  balanceTransferStore = useBalanceTransferStore();

  BalanceTransferMethod = BalanceTransferMethod;

  get nextDisabled () {
    return this.balanceTransferStore.transferMethod === BalanceTransferMethod.None;
  }

  updateSelection (transferMethod: BalanceTransferMethod) {
    this.balanceTransferStore.transferMethod = transferMethod;
  }

  isSelected (transferMethod: BalanceTransferMethod) {
    return this.balanceTransferStore.transferMethod === transferMethod;
  }

  onSkip () {
    this.$router.push({ name: Home });
  }

  onNext () {
    switch (this.balanceTransferStore.transferMethod) {
      case BalanceTransferMethod.TrusteeToTrustee:
        this.balanceTransferStore.goToStep("trustee-details");
        break;
      case BalanceTransferMethod.Rollover:
        this.balanceTransferStore.goToStep("rollover-details");
        break;
    }
  }
}
